import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProductionRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Si on est en production et qu'on n'est pas déjà sur la page beta-ending
    if (environment.production && state.url !== '/beta-ending') {
      this.router.navigate(['/beta-ending']);
      return false;
    }

    return true;
  }
}
